import axios from 'axios';

const API_BASE = 'https://backend.onstats.rep.software';

const api = axios.create({
  baseURL: API_BASE,
  timeout: 15000,
});

// Get player ranking (paginated)
export const getPlayersRanking = async (page = 1, pageSize = 50, usernameFilter = '', minBlocks = 1000) => {
  const params = { page, page_size: pageSize, min_blocks: minBlocks };
  if (usernameFilter) params.username_filter = usernameFilter;
  const { data } = await api.get('/stats/rank/players', { params });
  return data;
};

// Get all stats
export const getAllStats = async () => {
  const { data } = await api.get('/stats/');
  return data;
};

// Get player stats by username
export const getPlayerStats = async (username) => {
  const { data } = await api.get(`/stats/players/${username}`);
  return data;
};

// Get player total
export const getPlayerTotal = async (username) => {
  const { data } = await api.get(`/stats/players/${username}/total`);
  return data;
};

// Get player history (for charts)
export const getPlayerHistory = async (username, serverName = '') => {
  const params = {};
  if (serverName) params.server_name = serverName;
  const { data } = await api.get(`/stats/players/${username}/history`, { params });
  return data;
};

// Get all servers
export const getServers = async () => {
  const { data } = await api.get('/servers/');
  return data;
};

// Get all players
export const getPlayers = async (username = '') => {
  const params = {};
  if (username) params.username = username;
  const { data } = await api.get('/players/', { params });
  return data;
};

// Mojang skin helpers
export const getSkinUrl = (username) => `https://mc-heads.net/avatar/${username}/64`;
export const getBodyUrl = (username) => `https://mc-heads.net/body/${username}/128`;
export const getHeadUrl = (username) => `https://mc-heads.net/head/${username}/64`;

export default api;
